import * as React from "react";
const SvgEs = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", id: "flag-icons-es", viewBox: "0 0 640 480", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#c60b1e", d: "M0 0h640v480H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#ffc400", d: "M0 120h640v240H0z" }));
export default SvgEs;
